import { Box } from '@mui/system';
import { FormProvider, useForm } from 'react-hook-form';
import { CompanyDto } from 'tdc-web-backend/companies/schemas';
import { Dispatch, SetStateAction } from 'react';
import { EnumTechTool } from 'tdc-web-backend/enums/enums';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../../../../../../../../../components/confirm-modal/ConfirmModal';
import { ReactComponent as SuitcaseCheckIcon } from '../../../../../../../../../../assets/icons/layout-icons/SuitcaseCheckIcon.svg';
import { primaryLight } from '../../../../../../../../../../utils/color';
import { useRefresh } from '../../../../../../../../../../utils/hooks/crud-hooks/useRefresh';
import { mapTechTool } from '../../../../../../../../../../utils/enums';
import CustomInput from '../../../../../../../../../../components/custom-input/CustomInput';
import useUserCompany from '../../../../../../../../../../utils/hooks/useUserCompany';

interface CompanyTechToolsEditModalProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyTechToolsEditModal = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyTechToolsEditModalProps) => {
  const { company: companyData, updateCompany, isLoadingUpdateCompany } = useUserCompany();
  const refresh = useRefresh();

  const methods = useForm<Pick<CompanyDto, 'techTools'>>({
    mode: 'onChange',
    defaultValues: {
      techTools: companyData?.techTools ?? ([] as EnumTechTool[]),
    },
  });
  const { t } = useTranslation();
  const onSubmit = (data: Pick<CompanyDto, 'techTools'>) => {
    updateCompany(
      { techTools: data.techTools },
      {
        onSuccess: () => {
          refresh();
          setIsEditModalOpen(false);
        },
      },
    );
  };

  return (
    <ConfirmModal
      width="40%"
      title={t('settings.companyProfile.techTools')}
      onCancel={() => setIsEditModalOpen(false)}
      onConfirm={methods.handleSubmit(onSubmit)}
      isModalOpen={isEditModalOpen}
      setIsModalOpen={setIsEditModalOpen}
      confirmButtonText={t('common.save')}
      automaticallyCloseModalOnButtonClick={false}
      isLoading={isLoadingUpdateCompany}
      iconProps={{
        icon: <SuitcaseCheckIcon fill={primaryLight[500]} />,
        wrapperBackgroundColor: primaryLight[100],
      }}
      message={
        <FormProvider {...methods}>
          <Box component="form">
            <CustomInput
              input={<CustomInput.Autocomplete />}
              choices={mapTechTool}
              name="techTools"
              label={t('settings.companyProfile.techTools')}
              multiple
              placeholder={t('common.select')}
              sx={{ width: '100%' }}
            />
          </Box>
        </FormProvider>
      }
    />
  );
};
export default CompanyTechToolsEditModal;
